module.exports = __webpack_public_path__ + "static/media/PICK_OFF.e4072252.svg";